module.exports = __webpack_public_path__ + "img/index-spline-icon.53646be6.png";